var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"3vw"}},[_c('bulletFrame',{attrs:{"title":_vm.title,"name":_vm.name}}),_vm._v("\n  "+_vm._s(_vm.time)+"\n  "),_c('picke',{on:{"child-method":_vm.parentMethod}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-563b33fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/picke.vue
// module id = null
// module chunks = 